var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.8 5.546c.406 0 .744.3.794.691l.006.1v6.252h.8V7.902c0-.405.307-.736.7-.785l.1-.006h1.6c.406 0 .744.3.794.692l.006.1v4.686h.4a.4.4 0 0 1 .08.792l-.08.008H1a.4.4 0 0 1-.08-.792L1 12.59h.4V10.25c0-.405.307-.737.7-.785l.1-.006h1.6c.406 0 .744.3.794.691l.006.1v2.339h.8V6.337c0-.405.307-.737.7-.785l.1-.006h1.6zm-4.001 4.712H2.2l-.001 2.331h1.6v-2.331zM7.8 6.346H6.2v6.243h1.6V6.346zm3.999 1.564H10.2l-.001 4.679h1.6V7.91zM13.004.85a.4.4 0 0 1 .15.031l.061.032a.402.402 0 0 1 .07.057l.022.023.014.018.005.008-.008-.009.011.014.03.049a.408.408 0 0 1 .04.138l.001.039v2.348a.4.4 0 0 1-.792.08l-.008-.08-.001-1.398-2.013 1.97c-.378.37-.915.528-1.422.432l-.152-.036-3.044-.796a.822.822 0 0 0-.698.134l-.08.069-3.11 3.043a.4.4 0 0 1-.612-.51l.052-.062L4.63 3.4a1.618 1.618 0 0 1 1.39-.437l.15.032 3.056.8a.821.821 0 0 0 .718-.127l.083-.07 1.991-1.949H10.6a.4.4 0 0 1-.392-.32l-.008-.08a.4.4 0 0 1 .32-.392L10.6.85h2.404z",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.07f04a818cc86149678b81a08d2137b4.svg";
export { ForwardRef as ReactComponent };